export default "__VITE_ASSET__BEM3PzIA__"